/* eslint-disable eqeqeq */
import moment, { Moment } from "moment";
import {
  ISearchedEstimate,
  AvailableTimeSlotsObject,
} from "./CommonProps";
import { StampedService } from "./StampedService";
import { IBodyshopService } from "./UserService";
import { JobEstimationDetail } from "./modals/JobEstimationDetail";

export enum SortType {
  text = 1,
  number = 2,
  date = 3,
}

export enum sortOrder {
  asc = "asc",
  desc = "desc",
}

export class Common {
  createCustomerInStamped(
    stampedService: StampedService,
    estimateDetails: JobEstimationDetail,
    ibsService: IBodyshopService,
    showHideLoader: (value: boolean) => void,
    callback: () => void = function () { }
  ) {
    stampedService
      .addOrUpdateCustomer(
        {
          firstName: estimateDetails.firstName,
          lastName: estimateDetails.lastName,
          email: estimateDetails.email,
        },
        stampedService.customerId
      )
      .then((res) => {
        stampedService.currentCustomerPoints = res.points;
        stampedService.referralCode = res.referralCode;
        stampedService.referralUrl = res.referralUrl;
        if (!res.isSubscribed) {
          stampedService.subscribeCustomer(res.email).then((res1) => {
            ibsService
              .updateReferenceNumber(
                estimateDetails.estimateId,
                res.referralCode
              )
              .then((res) => {
                showHideLoader(false);
                if (callback) callback();
              });
          });
        } else {
          ibsService
            .updateReferenceNumber(estimateDetails.estimateId, res.referralCode)
            .then((res) => {
              showHideLoader(false);
              if (callback) callback();
            });
        }
      });
  }

  isAuthorityRequested(
    estimateDetails: JobEstimationDetail,
    isLinkOpenedFromEmail: boolean
  ) {
    return isLinkOpenedFromEmail
      ? true
      : estimateDetails &&
      estimateDetails.canAuthorise &&
      estimateDetails.canCancelAuthorityRequest; // && estimateDetails.header.jobBooking != null;
  }

  isEstimateScreenActionRequired(
    estimateDetails: JobEstimationDetail,
    isLinkOpenedFromEmail: boolean
  ) {
    return (
      (isLinkOpenedFromEmail
        ? estimateDetails
          ? estimateDetails.authorisationOutcome == "NotAuthorised"
          : false
        : estimateDetails
          ? estimateDetails.authorisationOutcome == "NotAuthorised" &&
          this.isAuthorityRequested(estimateDetails, isLinkOpenedFromEmail)
          : false) && !this.isEstimateDeclined(estimateDetails)
    );
  }

  isBookingScreenActionRequired(
    estimateDetails: JobEstimationDetail,
    isLinkOpenedFromEmail: boolean
  ) {
    return (
      estimateDetails.jobNumber == 0 &&
      !this.isEstimateScreenActionRequired(
        estimateDetails,
        isLinkOpenedFromEmail
      )
    );
  }

  isRepairTrackerActionRequired(
    estimateDetails: JobEstimationDetail,
    status: string,
    isLinkOpenedFromEmail: boolean
  ) {
    return (
      estimateDetails &&
      estimateDetails.jobIssuedDate != null &&
      !this.isBookingScreenActionRequired(
        estimateDetails,
        isLinkOpenedFromEmail
      ) &&
      (status != "Ready for Pickup" || !estimateDetails.isVehicleCollected)
    );
  }
  isEstimateFeedbackRequired(
    status: string,
    estimateDetails: JobEstimationDetail,
    isLinkOpenedFromEmail: boolean
  ) {
    return estimateDetails?.isVehicleCollected;
    // status == "Ready for Pickup" && estimateDetails.header.isJobCompleted;
  }
  isEstimateDeclined(estimateDetails: JobEstimationDetail) {
    return estimateDetails && estimateDetails.isCancelled;
  }
  getEstimateStatus(
    estimateDetails: JobEstimationDetail,
    isLinkOpenedFromEmail: boolean
  ) {
    if (estimateDetails) {
      if (estimateDetails.isCancelled) {
        return estimateDetails.cancellationReason == "Decline Estimate"
          ? "Rejected"
          : estimateDetails.cancellationReason;
      } else if (
        this.isEstimateScreenActionRequired(
          estimateDetails,
          isLinkOpenedFromEmail
        ) ||
        (estimateDetails.canAuthorise && !estimateDetails.canCancelAuthority)
      ) {
        return "Pending";
      } else {
        return "Accepted";
      }
    }
    return "";
  }
  getReferalStatus(item: ISearchedEstimate) {
    return item.isVehicleCollected
      ? "Completed"
      : item.isVehicleOnSite
        ? "Pending"
        : item.isCancelled
          ? "Rejected"
          : "Pending";
  }
  private isValueExist(obj: any, key: string, subKey: string) {
    return subKey
      ? obj[key] && obj[key][subKey] && obj[key][subKey] != ""
      : obj[key] && obj[key] != "";
  }
  private getValue(obj: any, key: string, subKey: string) {
    return subKey ? obj[key][subKey] : obj[key];
  }
  public getSortedDataWithKey(
    arr: any[],
    key: string,
    order: sortOrder,
    sortType: SortType,
    subKey: string = ""
  ) {
    let isValueExist = this.isValueExist;
    if (!sortType) {
      sortType = SortType.text;
    }
    var sortdata = arr.sort((a, b) => {
      var x = a[key];
      var y = b[key];
      if (subKey) {
        x = a[key][subKey];
        y = b[key][subKey];
      }
      switch (sortType) {
        case SortType.text:
          x = isValueExist(a, key, subKey)
            ? this.getValue(a, key, subKey).toString().toLowerCase()
            : "";
          y = isValueExist(b, key, subKey)
            ? this.getValue(b, key, subKey).toString().toLowerCase()
            : "";
          break;
        case SortType.date:
          x = isValueExist(a, key, subKey)
            ? new Date(this.getValue(a, key, subKey))
            : null;
          y = isValueExist(b, key, subKey)
            ? new Date(this.getValue(b, key, subKey))
            : null;
          break;
        case SortType.number:
          x = isValueExist(a, key, subKey)
            ? Number(this.getValue(a, key, subKey))
            : null;
          y = isValueExist(b, key, subKey)
            ? Number(this.getValue(b, key, subKey))
            : null;
          break;
      }

      if (order == "asc") {
        if (x < y) return -1;
        if (x > y) return 1;
      } else if (order == "desc") {
        if (x > y) return -1;
        if (x < y) return 1;
      }
      return 0;
    });

    return sortdata;
  }

  public showEstimateAmount(debtorName: string) {
    var configArray: any = {
      Private: true,
      "AUTO & GENERAL SERVICES PTY LTD": false,
      Rework: false,
    };
    return configArray[debtorName] != false ? true : false;
  }
}
// Service for distributing times based on AM and PM
export function separateAMPM(times: any): { am: any; pm: any } {
  const amTimes: any = [];
  const pmTimes: any = [];

  times.forEach((timeSlot: any) => {
    let timeStr = timeSlot.time;

    // If time does not already have AM/PM, convert it
    if (!timeStr.includes("AM") && !timeStr.includes("PM")) {
      timeStr = moment(timeStr, "HH:mm:ss").format("hh:mm A"); // Convert to 12-hour format
    }

    // Update the time in the object
    const updatedTimeSlot = { ...timeSlot, time: timeStr };

    if (timeStr.includes("AM")) {
      amTimes.push(updatedTimeSlot);
    } else if (timeStr.includes("PM")) {
      pmTimes.push(updatedTimeSlot);
    }
  });

  return { am: amTimes, pm: pmTimes };
}

export function groupByDayOfWeek(arr: any) {
  return arr.reduce((acc: any, item: any) => {
    const { dayOfWeek } = item;
    if (!acc[dayOfWeek]) {
      acc[dayOfWeek] = [];
    }
    acc[dayOfWeek].push(item);
    return acc;
  }, {});
};

export function formatTime(timeString: string) {
  return moment(timeString, "HH:mm").format("h:mm A");
}

export function getWeekStartAndEnd(dateStr: Moment | string, month?: boolean) {
  const date = moment(dateStr); // Parse the input date

  if (month) {
    // If "month" parameter is true, return a 3-month range
    const start = date.clone().startOf("day").format("YYYY-MM-DDT00:00:00.0000000");
    const end = date.clone().add(3, "months").startOf("day").format("YYYY-MM-DDT00:00:00.0000000");

    return { start, end };
  }

  // Default behavior: 7-day range (one week starting from Monday)
  const start = date.clone().startOf("isoWeek").format("YYYY-MM-DDT00:00:00.0000000");
  const end = date.clone().startOf("isoWeek").add(7, "days").format("YYYY-MM-DDT00:00:00.0000000");

  return { start, end };
}

export function filteredAvailableSlotsFromBookSlots(availableSlots: any, bookSlots: any) {
  const filteredSlots = availableSlots.filter((availability: any) => {
    // Convert dayOfWeek string (e.g., "Tuesday") to a numerical representation (0=Sunday, 1=Monday,...)
    const availabilityDayIndex = moment().day(availability.dayOfWeek).isoWeekday(); // Get correct weekday index
    const availabilityTime = moment(availability.startTime, "HH:mm:ss").format("HH:mm"); // Convert to correct format

    return !bookSlots.some((item: any) => {
      const bookedMoment = moment(item);
      const bookedDayIndex = bookedMoment.isoWeekday(); // Ensure same format as availabilityDayIndex
      const bookedTime = bookedMoment.format("HH:mm"); // Get booked time in correct format

      return bookedDayIndex === availabilityDayIndex && bookedTime === availabilityTime;
    });
  });

  return filteredSlots;
}

export function findClosestPastTimeSlot(
  slotsArray: AvailableTimeSlotsObject[],
  referenceDate?: string // Allow a custom reference date (optional)
): AvailableTimeSlotsObject | null {
  const today = referenceDate ? moment(referenceDate, "YYYY-MM-DD") : moment();
  let nearestPastDate: AvailableTimeSlotsObject | null = null;
  let minDiff = Infinity;
  for (const obj of slotsArray) {
    const date = moment(obj.effectiveFromDate, "YYYY-MM-DD");
    if (date.isSameOrBefore(today)) {
      const diff = Math.abs(date.diff(today, "days"));
      // Return immediately if an exact match is found
      if (date.isSame(today, "day")) return obj;
      // Update nearest past date
      if (diff < minDiff) {
        minDiff = diff;
        nearestPastDate = obj;
      }
    }
  }
  return nearestPastDate;
}

export const filterDates = (availableSlots: AvailableTimeSlotsObject[] = []): AvailableTimeSlotsObject[] => {
  const nearestPastDateObj = findClosestPastTimeSlot(availableSlots);
  const referenceDate = nearestPastDateObj?.effectiveFromDate ?? moment().format("YYYY-MM-DD"); // Use nearest past date or current date

  // Sort dateList in ascending order based on `effectiveFromDate`
  const sortedDateList = availableSlots
    .filter(dateItem => dateItem?.effectiveFromDate) // Remove invalid entries
    .sort((a, b) => moment(a.effectiveFromDate).diff(moment(b.effectiveFromDate)));

  // Find the first index where effectiveFromDate >= referenceDate
  const firstFutureDateIndex = sortedDateList.findIndex(dateItem =>
    moment(dateItem.effectiveFromDate).isSameOrAfter(moment(referenceDate))
  );

  if (firstFutureDateIndex !== -1) {
    return sortedDateList.slice(firstFutureDateIndex); // Return future dates
  }

  // If no future dates exist, return only the last past date (or an empty array if none exist)
  return sortedDateList.length ? [sortedDateList[sortedDateList.length - 1]] : [];
};

function assignDatesToSlots(slotsArray: AvailableTimeSlotsObject[]): any[] {
  return slotsArray?.map((data, index) => {
    const { sortedTimeSlots, effectiveFromDate } = data;
    let effectiveDate = moment(effectiveFromDate);
    const today = moment();

    if (effectiveDate.isBefore(today, 'day')) {
      effectiveDate = today.clone();
    }

    let endDate = index === slotsArray.length - 1 ? moment(today).add(3, 'months') : moment(slotsArray[index + 1].effectiveFromDate);

    const daysMap: Record<string, number> = {
      "Sunday": 0, "Monday": 1, "Tuesday": 2, "Wednesday": 3,
      "Thursday": 4, "Friday": 5, "Saturday": 6
    };

    const weeklyDates: Record<string, string[]> = {};
    Object.keys(daysMap).forEach(day => {
      weeklyDates[day] = [];
      let nextDate = moment(effectiveDate).day(daysMap[day]);
      if (nextDate.isBefore(effectiveDate, 'day')) nextDate.add(7, 'days');
      while (nextDate.isBefore(endDate)) {
        weeklyDates[day].push(nextDate.format("YYYY-MM-DD"));
        nextDate.add(7, 'days');
      }
    });

    const expandedTimeSlots = sortedTimeSlots.flatMap(slot => {
      const validDates = (weeklyDates[slot.dayOfWeek] || []).filter(date => moment(date).isBefore(endDate));
      return validDates.map(date => ({ ...slot, date }));
    });

    return expandedTimeSlots.length > 0 ? { ...data, sortedTimeSlots: expandedTimeSlots } : null;
  }).filter(Boolean);
}

function getFullyBookedDates(slots: any[], bookings: any[]): string[] {
  // Convert booked slots from bookings array into a Set for quick lookup
  const bookedSlots = new Set<string>();

  bookings.forEach(entry => {
    const formattedDateTime = moment(entry.dueDate).format("YYYY-MM-DD HH:mm:ss");
    bookedSlots.add(formattedDateTime);
  });

  // Group available slots by date
  const availableSlotsByDate: Record<string, Set<string>> = {};

  slots.forEach(slot => {
    if (!availableSlotsByDate[slot.date]) {
      availableSlotsByDate[slot.date] = new Set();
    }
    availableSlotsByDate[slot.date].add(slot.startTime);
  });

  // Identify fully booked dates
  const fullyBookedDates = new Set<string>();

  Object.entries(availableSlotsByDate).forEach(([date, availableTimes]) => {
    const allBooked = Array.from(availableTimes).every(time => bookedSlots.has(`${date} ${time}`));
    if (allBooked) {
      fullyBookedDates.add(date);
    }
  });

  return Array.from(fullyBookedDates);
}

export const getDisabledDates = (slotsArray: AvailableTimeSlotsObject[], bookedTimeSlots: any[]): string[] => {
  const schedules = filterDates(slotsArray);

  const filteredSchedules = schedules.filter(schedule => schedule.sortedTimeSlots.length > 0);
  const disabledDates: string[] = [];
  const today = moment();
  const threeMonthsLater = moment().add(3, "months");

  filteredSchedules.sort((a, b) => moment(a.effectiveFromDate).diff(moment(b.effectiveFromDate)));

  const scheduleDateRanges: { start: moment.Moment; end: moment.Moment; validDays: Set<string> }[] = [];

  for (let i = 0; i < filteredSchedules.length; i++) {
    const currentSchedule = filteredSchedules[i];
    const nextSchedule = filteredSchedules[i + 1];
    const startDate = moment(currentSchedule.effectiveFromDate);
    const endDate = nextSchedule ? moment(nextSchedule.effectiveFromDate).subtract(1, "day") : threeMonthsLater;
    const validDays = new Set(currentSchedule.sortedTimeSlots.map(slot => slot.dayOfWeek));
    scheduleDateRanges.push({ start: startDate, end: endDate, validDays });
  }

  let currentDay = today.clone();
  while (currentDay.isBefore(threeMonthsLater, "day")) {
    const dayOfWeek = currentDay.format("dddd");
    const applicableSchedule = scheduleDateRanges.find(range =>
      currentDay.isBetween(range.start, range.end, "day", "[]")
    );
    if (applicableSchedule && !applicableSchedule.validDays.has(dayOfWeek)) {
      disabledDates.push(currentDay.format("YYYY-MM-DD"));
    }
    currentDay.add(1, "day");
  }

  // For Booking Date 
  const slotsWithAssignedDates = assignDatesToSlots(filteredSchedules);
  const availableSlotsWithAssignDates = slotsWithAssignedDates?.slice(0, 2)?.flatMap(({ sortedTimeSlots }) => sortedTimeSlots);

  const bookedSlots = bookedTimeSlots?.map(({ dueDate }) => ({ dueDate }));
  const fullyBookedDates = getFullyBookedDates(availableSlotsWithAssignDates, bookedSlots);
  const sortedDisabledAndBookedDates = [...disabledDates, ...fullyBookedDates].sort((a, b) => a.localeCompare(b));

  return sortedDisabledAndBookedDates;
};
